import React from 'react';
import { useNavigate } from 'react-router-dom';
import BacktestPage from '../components/BacktestPage';
import { usePortfolio } from '../context/PortfolioContext';
import { useAuth } from '../context/AuthContext';
import PageOnboarding from '../components/PageOnboarding';

const BACKTEST_ONBOARDING_STEPS = [
  {
    title: 'Backtest Your Portfolio',
    message: 'See how your optimized portfolio would have performed using historical data. This helps validate the strategy before investing.',
  },
  {
    title: 'Understanding the Results',
    message: 'The chart shows cumulative returns over time. Compare your optimized portfolio against individual funds to see the diversification benefit.',
  },
  {
    title: 'Key Metrics',
    message: 'Review Max Drawdown (largest drop), CAGR (annual growth rate), and other metrics to understand risk and return characteristics.',
  },
];

const BacktestPageWrapper = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { selectedFunds } = usePortfolio();

  return (
    <>
      <BacktestPage
        selectedFunds={selectedFunds}
        onBack={() => navigate('/results')}
      />
      <PageOnboarding
        pageId="backtest"
        userEmail={user?.email}
        steps={BACKTEST_ONBOARDING_STEPS}
      />
    </>
  );
};

export default BacktestPageWrapper;
